<template>
  <!--
  <div
    v-if="[3,4,5,6,7].includes(current_month)"
    @click="() => $router.push('/dilo-con-nieve')"
    id="carouselExampleIndicators"
    class="carousel slide"
    data-interval="4000"
  >
    <div class="carousel-inner">
      <div class="carousel-item active">
        <img class="d-block w-100 banner" src="@/assets/store/diloconnieve/diloconnieve_banner.jpg" alt="First slide">
      </div>
    </div>
  </div>
  -->

  <div :style="`${!banners.length ? 'margin-bottom: 50%' : ''}`" id="carouselExampleIndicators" class="carousel slide" data-interval="4000">
    <!--<ol v-if="banners.length" class="carousel-indicators carousel-indicators--thumbnails">
      <li v-for="(item,i) in banners" :key="i" data-target="#carouselExampleIndicators" data-slide-to="0" :class="`${i == 0 ? 'active' : ''}`">
      </li>
    </ol>
    -->
    <div class="carousel-inner">
      <div
        v-for="(item,i) in banners"
        :key="i"
        :class="`carousel-item ${i == 0 ? 'active' : ''} ${item.dcn ? 'cursor-pointer' : ''}`"
      >
        <img
          class="d-block w-100 banner"
          :src="item.src_image"
          alt="First slide"
          @click="() => item.dcn && $router.push('/dilo-con-nieve')"
        >
      </div>
    </div>
    <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="sr-only">Previous</span>
    </a>
    <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="sr-only">Next</span>
    </a>
  </div>

</template>

<script>

import { mapState } from 'vuex'

export default {
  props: ['banners'],
  computed: {
    ...mapState(['current_month'])
  },
  mounted() {
    window.$('.carousel').carousel();
  }
}
</script>

<style scoped>
@media only screen and (min-width: 2507px) and (max-width: 3500px) {
  .carousel-item .banner {
    height: 100vh !important;
  }
}
@media only screen and (min-width: 2001px) and (max-width: 2506px) {
  .carousel-item .banner {
    height: 110vh !important;
  }
}

/*.carousel-indicators {
  bottom: 30px !important;
}
.carousel-indicators.carousel-indicators--thumbnails li {
  width: 35px;
  height: 35px;
  margin: 0;
  border: none;
  border-radius: 0;
  background: url('../../assets/store/home/36.png');
  background-size: contain;
  background-repeat: no-repeat;
}
.carousel-indicators.carousel-indicators--thumbnails .active {
  background-color: transparent;
}
.carousel-indicators.carousel-indicators--thumbnails .active .thumbnail {
  border-color: #337ab7;
}
@media only screen and (min-width: 1720px) and (max-width: 3000px) {
  .carousel-indicators.carousel-indicators--thumbnails li {
    width: 80px !important;
    height: 80px !important;
  }
}*/
</style>
